export default __webpack_public_path__ + "static/media/k9.a1ac42a2.jpg";